module.exports = __webpack_public_path__ + "static/media/background.701f1e89.jpg";